import {Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Observable} from 'rxjs';
import {WarningModalContentComponent} from "../../lib/warning-modal/warning-modal.component";

@Injectable({
  providedIn: 'root'
})
export class WarningModalService {

  bsModalRef!: BsModalRef;

  constructor(
    private modalService: BsModalService
  ) {
  }

  confirm(title?, message?, negateResult?, cancelButton?, agreeButton?, nested?, showWarningIcon?, icon?, onDeleteModal?,isDeleteBanner = false, isTmpDelete = false): Observable<boolean> {
    const initialState = {};
    if (title !== undefined) {
      initialState['title'] = title;
    }
    if (message !== undefined) {
      initialState['message'] = message;
    }
    if (negateResult !== undefined) {
      initialState['negateResult'] = negateResult;
    } else {
      initialState['negateResult'] = false;
    }
    if (cancelButton !== undefined) {
      initialState['cancelButton'] = cancelButton;
    } else {
      initialState['cancelButton'] = $localize`No`;
    }
    if (agreeButton !== undefined) {
      initialState['agreeButton'] = agreeButton;
    } else {
      initialState['agreeButton'] = $localize`Yes`;
    }
      if (showWarningIcon !== undefined) {
        initialState['showWarningIcon'] = showWarningIcon;
        if (showWarningIcon && icon !== undefined) {
          initialState['icon'] = icon;
        }
      }
      if (onDeleteModal !== undefined){
        initialState['onDeleteModal'] = onDeleteModal;
      }

      initialState['isDeleteBanner'] = isDeleteBanner;
      initialState['isTmpDelete'] = isTmpDelete;

    if (nested) {
      this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
        class: 'modal-dialog-centered default-modal nested-modal', initialState
      });
    } else {
      this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
        class: 'modal-dialog-centered default-modal', initialState
      });
    }

    return this.bsModalRef.content.getSelectionObservable();
  }
}
